/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */
export var BASE_ERROR = 'field_not_equal_to';
/**
 * Creates validator for checking equality of two fields
 *
 * @function equalToField
 * @param {string} otherFieldName Name of the other field
 * @return {validator} Field equality validator
 */

export default function equalToField(otherFieldName) {
  if (!otherFieldName) throw Error('Field name to compare against must be provided.');
  return function (value, otherFields) {
    if (value && otherFields[otherFieldName] && otherFields[otherFieldName] !== value) return "".concat(BASE_ERROR, "_").concat(otherFieldName);
    return null;
  };
}